let class2type = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regexp',
    '[object Object]': 'object',
    '[object Error]': 'error',
    '[object Symbol]': 'symbol'
};

// 判断类型
export function getType(obj) {
    if (obj == null) {
        return obj + '';
    }

    let str = Object.prototype.toString.call(obj);
    return typeof obj === 'object' || typeof obj === 'function' ?
        class2type[str] || 'object' : typeof obj;
}

/**
 * html 转义
 *
 * @param {string} html 要处理的字符串
 * @returns 经过html转义的字符串
 */
export function htmlEscape(html) {
    let div = document.createElement('div');
    div.appendChild(document.createTextNode(html));
    let s = div.innerHTML;
    div = null;
    return s;
}

/**
 * html 还原转义
 */
export function htmlUnescape(str) {
    if (typeof str !== 'string') return str;
    let s = '';
    if (str.length == 0) return '';
    s = str.replace(/&amp;/g, '&');
    s = s.replace(/&lt;/g, '<');
    s = s.replace(/&gt;/g, '>');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/&#39;/g, '\'');
    s = s.replace(/&quot;/g, '"');
    //s = s.replace(/<br>/g, "\n");
    return s;
}

/**
 * html XSS过滤
 * TODO: html XSS 注入的可能情况
 * 1、 script标签
 * 2、 style 样式中 url 发请求
 * 3、 资源型标签 src 触发
 * 4、 html行内事件，如onclick onmouseover等
 * @param {string} html 要处理的字符串
 * @returns 经过安全过滤html字符串
 */
export function getSafeHtml(html) {
    if (!html) return;
    // script 处理
    html = html.replace(/<script(.*?)>/gi, '<noscript$1>').replace(/<\/script>/gi, '</noscript>');

    return html;
}

// 对象合并
function assign() {
    let target = arguments[0];
    let i = 1,
        len = arguments.length,
        key = '',
        obj = null,
        hasOwnProperty = Object.prototype.hasOwnProperty;

    for (; i < len; i++) {
        obj = arguments[i];
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                target[key] = obj[key];
            }
        }
    }

    return target;
}

// 一天的毫秒数目
let DAY_MILLISECONDS = 1000 * 60 * 60 * 24;

// 统一的cookie配置
const DEFAULT_COOKIE_OPTIONS = {
    // 过期时间 单位天
    // expires: 30,
    // path: '/',
    // domain: '',
    // secure: false
};

// 设置cookie的默认配置
export function setCookieDefaultOption(opt) {
    for (let k in opt) {
        if (Object.prototype.hasOwnProperty.call(opt, k)) {
            DEFAULT_COOKIE_OPTIONS[k] = opt[k];
        }
    }
}

/**
 * 写入cookie
 *
 * @param {string} key cookie 名称
 * @param {string} value cookie 值
 * @param {object | undefined} options 当前cookie的配置 { expires,path,domain,secure }
 * @returns {string} 写入的cookie
 */
export function writeCookie(key, value, options) {
    if (!options || getType(options) != 'object') {
        options = assign({}, DEFAULT_COOKIE_OPTIONS, options || {});
    }

    // 过期时间
    if (getType(options.expires) == 'number') {
        let d = options.expires;
        options.expires = new Date();
        options.expires.setMilliseconds(options.expires.getMilliseconds() + d * DAY_MILLISECONDS);
    }
    return (document.cookie = [encodeURIComponent(key), '=', value,
        options.expires ? '; expires=' + options.expires.toUTCString() : '',
        options.path ? '; path=' + options.path : '',
        options.domain ? '; domain=' + options.domain : '',
        options.secure ? '; secure' : ''
    ].join(''));
}

/**
 * 读取cookie
 *
 * @param {string} key cookie 名称
 * @returns 读取到的cookie值
 */
export function readCookie(key) {
    let result = key ? undefined : {},
        cookies = document.cookie ? document.cookie.split('; ') : [],
        i = 0,
        l = cookies.length;
    for (; i < l; i++) {
        let parts = cookies[i].split('='),
            name = decodeURIComponent(parts.shift()),
            v = parts.join('=');

        if (key === name) {
            result = v;
            break;
        }

        if (!key && v !== undefined) {
            result[name] = v;
        }
    }
    return result;
}

/**
 * 移除一个cookie
 *
 * @param {string} key cookie名称
 * @param {object} options cookie配置
 * @returns
 */
export function removeCookie(key, options) {
    options = options || {};
    options.expires = -1;
    writeCookie(key, '', options);
    return !readCookie(key);
}

// 绑定事件
function on(el, type, fn) {
    if (el.addEventListener) {
        el.addEventListener(type, fn, false);
    } else if (el.attachEvent) {
        el.attachEvent('on' + type, fn);
    }
}

/**
 * 安全Location对象的封装 IE9+ 可保障表现和location一样 IE8赋值需使用对应set方法
 */
function SafeLocation() {
    let that = this;
    this.origin = location.origin;

    this._writeProps = ['protocol', 'host', 'hostname', 'port', 'pathname', 'search', 'username', 'password'];
    this._isSupportDescriptor = !!Object.defineProperties;

    // 需要额外处理的 这两个属性会随时变化 需要不同的时候来获取
    // hash href
    let hash;
    if (this._isSupportDescriptor) {
        Object.defineProperties(this, {
            protocol: {
                get: function () {
                    return location.protocol;
                },
                set: function (v) {
                    location.protocol = v;
                }
            },
            host: {
                get: function () {
                    return location.host;
                },
                set: function (v) {
                    location.host = v;
                }
            },
            hostname: {
                get: function () {
                    return location.hostname;
                },
                set: function (v) {
                    location.hostname = v;
                }
            },
            port: {
                get: function () {
                    return location.port;
                },
                set: function (v) {
                    location.port = v;
                }
            },
            pathname: {
                get: function () {
                    return location.pathname;
                },
                set: function (v) {
                    location.pathname = v;
                }
            },
            search: {
                get: function () {
                    return location.search;
                },
                set: function (v) {
                    location.search = v;
                }
            },
            username: {
                get: function () {
                    return location.username;
                },
                set: function (v) {
                    location.username = v;
                }
            },
            password: {
                get: function () {
                    return location.password;
                },
                set: function (v) {
                    location.password = v;
                }
            },
            href: {
                get: function () {
                    return location.href;
                },
                set: function (v) {
                    // TODO 安全过滤
                    location.href = v;
                }
            },
            hash: {
                get: function () {
                    hash = location.hash;
                    return hash;
                },
                set: function (v) {
                    if ((v || '')[0] != '#') {
                        v = '#' + v;
                    }
                    // TODO 安全过滤
                    hash = location.hash = v;
                }
            }
        });
    } else {
        // 监听变化事件进行更新
        on(window, 'hashchange', function () {
            that.href = location.href;
            that.hash = location.hash;
        });
    }

    let props = this._writeProps.concat(['href', 'hash']);
    for (let i = 0, len = props.length; i < len; i++) {
        // 属性
        let p = props[i];
        // 对应方法
        let fnName = p[0].toUpperCase() + p.substr(1);
        (function (p, fnName) {
            // 支持描述符 则直接赋值
            if (that._isSupportDescriptor) {
                that['set' + fnName] = function (v) {
                    that[p] = v;
                };
            } else {
                that[p] = location[p];
                // 否则需要方法处理
                that['set' + fnName] = function (v) {
                    that[p] = location[p] = v;
                };
            }

            that['get' + fnName] = function () {
                return that[p];
            };
        })(p, fnName);
    }

    // IE8 下检测 直接赋值的更新
    if (!this._isSupportDescriptor) {
        setInterval(function () {
            for (let i = 0, l = props.length; i < l; i++) {
                let p = props[i];
                if (that[p] != location[p]) {
                    location[p] = that[p];
                }
            }
        }, 50);
    }
}

SafeLocation.prototype.replace = function (url) {
    // 安全过滤
    location.replace(url);
};

SafeLocation.prototype.reload = function () {
    location.reload();
};
SafeLocation.prototype.assign = function (url) {
    // 安全过滤
    location.assign(url);
};
SafeLocation.prototype.toString = function () {
    return this.href;
};

export function getSafeLocation() {
    return new SafeLocation();
}